import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ModeFanOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mode_fan_off"}/>
}
